import React from 'react';
import { IdView, Typography } from '../../../../components';
import { SettingsIc } from '../../../../components/icons';
import { OrderData } from '../types';

interface OrderIdCellProps {
  order: OrderData;
  onEditOrder: (order: OrderData) => void;
}

const OrderIdCell: React.FC<OrderIdCellProps> = ({ order, onEditOrder }) => {
  return (
    <div className="flex items-center gap-1">
      {/* <button
        onClick={() => onEditOrder(order)}
        className="hover:opacity-70 transition-opacity cursor-pointer"
      >
        <SettingsIc />
      </button> */}
      <IdView textToCopy={order.id}>{order.internalId}</IdView>
    </div>
  );
};

export default OrderIdCell;
